<div class="flex min-h-screen flex-col bg-white">
  <!-- Admin Header -->
<app-header
  [homeRoute]="'/exam/exam-panel/scan-qr'"
  [showPublicLinks]="false"
></app-header>

  <!-- Admin screen content -->
  <main class="flex-1">
    <router-outlet />
  </main>

  <!-- Admin Footer -->
   <div class="mt-10">
    <app-footer />
  </div>
</div>
